const hasZeroStudentsEnrolled = (courses) => {
  return courses.some((course) => course.enrollment === 0)
}
export default hasZeroStudentsEnrolled
